export default "/images/filter.svg?f342dd7b00319746f418bb18b1da51c3";